// extracted by mini-css-extract-plugin
export default {"container":"d0dlP4gN","wrapper":"uUtdBsVY","slide":"zs35dRLS"};